import { useQuery } from 'react-query';
import { client } from '../common/services';
import { QueryKeys } from '../common/types';
import { CaseHandlerResponseDto, PagedResponse } from '@bandido/shared/dtos';

interface UseGetCaseHandlersQueryParams {
  pageSize: number;
  currentPage: number;
  search: string;
  agencyId: number;
}

const getCaseHandlers = async (params: UseGetCaseHandlersQueryParams) => {
  const { pageSize, currentPage, search, agencyId } = params;
  const response = await client.get<PagedResponse<CaseHandlerResponseDto>>('ia-case-event-handlers', {
    params: { pageSize, currentPage, search, agencyId },
  });
  return response.data;
};

export const useGetCaseHandlersQuery = (params: UseGetCaseHandlersQueryParams) => {
  const { pageSize, currentPage, search, agencyId } = params;

  return useQuery({
    queryKey: [QueryKeys.getCaseHandlers, { pageSize, currentPage, search, agencyId }],
    queryFn: () => getCaseHandlers({ pageSize, currentPage, search, agencyId }),
    enabled: Boolean(agencyId),
  });
};
